import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";

import { validaSoloNumero } from "../../util/varios";
import "react-tabs/style/react-tabs.css";
import axios from "axios";
import CatalogoContable from "../../catalogos/catalogoContable";
import { DangerButton, SuccessButton } from "../../ui/buttons/Button";
import { Input, SearchInput } from "../../ui/inputs/Input";

export const ModalVincularHacienda = (props) => {
  let op = require("../../../src/modulos/datos");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [visible, setVisible] = useState(false);
  const txtId = useRef();
  const txtDescrip = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  let token = localStorage.getItem("jwtToken");

  const validarCampos = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtId.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe seleccioanr un codigo",
        icono: "informacion",
      });
      sigue = false;
      txtId.current.focus();
    }
    if (sigue === true) {
      actualizarVinculacion();
    }
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.setShow(false);
  };

  const actualizarVinculacion = () => {
    let endpoint = `${op.conexion}/api/contabilidadfis/vincularhacienda?idefiscal=${idefiscal}&id=${txtId.current.value}`;
    let body;
    setActivate(true);

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Vinculación Exitosa.",
            icono: "exito",
          });
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const blanquearCampos = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setActivate(false);
    setOperacion();
    setDeshabilitado();
    setVisible();
  };

  const salir = () => {
    props.setShow(false);
    blanquearCampos();
  };

  const seleccionarCuenta = (id) => {
    setMostrar(false);

    let endpoint = `${op.conexion}/api/contabilidadfis/selectctaconta?id=${id}&idefiscal=${idefiscal}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            console.log(response.data);

            txtId.current.value = response.data.idcuentacontable;
            txtDescrip.current.value = response.data.descripcion;

            setActivate(false);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe una Cuenta Contable con este Codigo.",
              icono: "informacion",
            });
            /*    txtDescripcion.current.value = ''; */
            setActivate(false);
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarCuenta = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    txtDescrip.current.value = "";
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarCuenta(event.target.value);
      } else {
        /*  cmbTipo.current.value = ''; */
        /*   txtCuentaContable.current.value = '';
                  txtDescripcion.current.value = ''; */
      }
    }
  };

  const seleccionarRegistro = () => {
    let endpoint = `${op.conexion}/api/contabilidadfis/selectcuentahacienda?idefiscal=${idefiscal}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idcuentacontable > 0) {
            txtId.current.value = response.data.idcuentacontable;
            seleccionarCuenta(response.data.idcuentacontable);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setDeshabilitado(props.deshabilitado);
        setOperacion(props.operacion);
        setVisible(false);
        seleccionarRegistro();
      }}
    >
      <Modal.Header className="azulGradiant">
        <h3 className="fw-bold m-0">Vincular Hacienda</h3>
        <a
          type="button"
          className="fw-bold text-light fs-6"
          onClick={salir}
          ref={btnCancela}
        >
          Salir<i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <fieldset className=" col-12 m-0 p-2 d-flex border-azul rounded">
          <legend className="float-none w-auto m-0">
            Relacion Cuenta Contable
          </legend>
          <SearchInput
            label="Hacienda:"
            type="text"
            onKeyUp={validarCuenta}
            onBlur={validarCuenta}
            name="idcuentabancaria"
            onClickButton={() => {
              setMostrar(true);
            }}
            ref={txtId}
          />
          <Input
            id="codigocuenta"
            disabled
            name="codigocuenta"
            ref={txtDescrip}
          />
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          ref={btnAcepta}
          disabled={operacion === 4 ? true : false}
          onClick={validarCampos}
        >
          Aceptar
        </SuccessButton>
        <DangerButton ref={btnCancela} onClick={salir}>
          Salir
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({
              mostrar: false,
              titulo: "",
              texto: "",
              icono: "",
            });
        }}
      />

      <Dimmer active={activate} inverted></Dimmer>
      <CatalogoContable
        show={mostrar}
        onHideCancela={() => {
          setMostrar(false);
        }}
        onHideAcepta={seleccionarCuenta}
      />
    </Modal>
  );
};
